import React from "react";
import { X, CreditCard } from "lucide-react";
import api from "./api";
import "./CreditPurchase.css";
import "./Modal.css";

const CreditPurchaseModal = ({ onClose }) => {
  const creditPackages = [
    { credits: 10000, price: 10 },
    { credits: 20000, price: 20 },
    { credits: 30000, price: 30 },
  ];

  const initiatePurchase = async (credits) => {
    try {
      // Backend uses fixed mapping for pricing, so we only send credits
      const response = await api.post("/users/credits/purchase", {
        credits,
      });

      // Redirect to Stripe Checkout
      window.location.href = response.data.url;
    } catch (err) {
      console.error("Failed to initiate purchase:", err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            <CreditCard className="text-blue-600" />
            Purchase Credits
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={24} />
          </button>
        </div>

        <div className="space-y-4">
          {creditPackages.map(({ credits, price }) => (
            <div
              key={credits}
              className="border rounded-lg p-4 hover:border-blue-500 cursor-pointer transition-all"
              onClick={() => initiatePurchase(credits)}
            >
              <div className="flex justify-between items-center">
                <div>
                  <h3 className="font-semibold text-lg">
                    {credits.toLocaleString()} Credits
                  </h3>
                  <p className="text-gray-600">${price}.00 USD</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-sm text-gray-500">
          1 credit = 1,000 tokens. Unused credits never expire.
        </div>
      </div>
    </div>
  );
};

export default CreditPurchaseModal;
